import React from 'react';
import StickerFishHealth from "../../../../../components/Location/FishHealth/StickerFishHealth";
import FishDisease from "../../../../../components/Operation/FishDisease";
import UnitLice from "../../../../../components/Operation/UnitLice";
import { useSiteDetail } from "../../../../../contexts/SiteDetailContext";
import { SITE_TYPE } from "../../../../../util/varibles/constants";
import FishAndWeight from "../../../../PlanOperationPage/BiologyBrowser/_components/FishAndWeight";
import Location from "../../../../PlanOperationPage/BiologyBrowser/_components/Location";
import UnitDiseases from "../../../../PlanOperationPage/BiologyBrowser/_components/UnitDiseases";
import styles from '../style.module.scss';

interface IProps {
}

const Units: React.FC<IProps> = React.memo(() => {
    const [site, set] = useSiteDetail(state => state.site);
    const [unit] = useSiteDetail(state => state.unit);

    const { type = SITE_TYPE.INTERNAL, units = [], diseases = [] } = site || {};

    const isInternal = type === SITE_TYPE.INTERNAL;

    return <div>
        <div className={styles.lineName}>
            All units
        </div>
        <div className={styles.units}>
            {units.map(item => {
                const isActive = item.id === unit?.id
                const { lice } = item;
                return <div
                    className={styles.unit}
                    key={item.id}
                    data-empty={item.fish_amount === 0 && isInternal}
                    data-active={item.id === unit?.id}
                    onClick={() => set({ unit: isActive ? undefined : item })}
                >
                    <StickerFishHealth value={item.fish_health} />
                    <div className={styles.unitLine}>
                        <Location source={[item.unit_id]} />
                        {isInternal && <FishAndWeight data={item} />}
                    </div>
                    <div className={styles.unitLine} data-right={true}>
                        <UnitLice lice={lice} />
                        <FishDisease diseases={diseases} units={[item]} short={true} />
                        <UnitDiseases data={site?.unit_diseases} />
                    </div>
                </div>
            })}
        </div>
    </div>;
});

export default Units;
